module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "clear"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("\n            #" + _vm._s(_vm.data.id) + " - " + _vm._s(_vm.types[_vm.data.type]) + " "), (_vm.data.description) ? _c('span', [_vm._v(" - " + _vm._s(_vm.data.description))]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.data.product_id) ? _c('div', {
    staticClass: "product-info"
  }, [_c('product', {
    attrs: {
      "id": _vm.data.product_id
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v(_vm._s(_vm.data.created_at))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17526aad!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notification.vue
// module id = 1240
// module chunks = 2